// Company/companyLinks.ts
export const companyLinks = {
    whatsapp: 'https://wa.me/79297600963',
    telegramContact: 'https://t.me/Life_Help_psychologist',
    telegramSocial: 'https://t.me/Life_Help_psychologist',
    odnoklassniki: 'https://ok.ru/group/70000003989140',
    vk: 'https://vk.com/life_help',
    yandexZen: 'https://dzen.ru/lifehelppsihology',
    blog: 'https://life-help.ru/lifehelp-services/blog',
    forum: '',
    consultations: 'https://life-help.ru/lifehelp-services/online-consultations',
    for_psy_intervision: 'https://life-help.ru/lifehelp-services/intervision',
    for_psy_supervision: 'https://life-help.ru/lifehelp-services/supervision',
    for_business: 'https://life-help.ru/lifehelp-services/psychology-for-business',
    for_tests: 'https://life-help.ru/lifehelp-services/tests',
    consentMailing: '/consent-mailing/',
    privacyPolicy: '/privacy-policy/',
    contractOffer: '/contract-offer',
    agreement: '/agreement/',
};

// path('consent-mailing/',RedirectView.as_view(url='/static/core/docs/mailing.pdf',
//          permanent=True)),
// path('agreement/', RedirectVew.as_view(url='/static/core/docs/agreement.pdf',
//          permanent=True)),
// path('privacy-policy/',RedirectView.as_view(url='/static/core/docs/policy.pdf',
//          permanent=True)),